import styled from 'styled-components'
import tw from 'twin.macro'

export const Wrapper = styled.div`
  ${tw`fixed flex flex-col-reverse right-0 left-0 top-0 z-l10 w-full justify-center items-center`};
  background: rgba(71, 85, 105, 0.4);

  ${(props) => props.css}
`

export const Container = styled.div`
  ${tw`relative w-full flex flex-col rounded-t-16px justify-center items-center`};

  ${(props) => props.css}
`
